<template> 
    <div class="w-100 stepAreaMain">
        <!-- <div>
            <div class="globalHeader w-100">
                <header class="text-right d-flex align-items-center justify-content-between">
                    <div class="d-flex">
                        <div class="Steplogo ">
                            <a href="/dashboard" class="green">
                                <img src="/static/fxView/images/logo-black.svg" alt="fxView">
                            </a>
                        </div>
                    </div>
                    <div class="backSection">
                        <a href="/dashboard" class="back"><feather type="home" ></feather> </a>
                        <a href="#" class="back"><feather type="chevron-left" ></feather> </a> 
                    </div>
                </header>
            </div>
            <div class="d-flex justify-content-center align-items-center stepListing">
                <ul class="d-flex">
                    <li>  
                        <a href="#" :class="(tab_active == 1)?'active':''" @click.prevent="tab_active = 1">
                            <span class="steps">1</span>
                            <h3>Personal Information</h3>
                        </a>
                        
                    </li>
                    <li :class="(parseInt(get_user.step) == 0)?'disbale':''"> 
                        <a href="#" :class="(tab_active == 2)?'active':''" @click.prevent="tab_active = 2">
                         <span class="steps">1</span>
                         <h3>Declaration</h3>
                     </a>
                       
                    </li>
                    <li :class="(parseInt(get_user.step) == 0 || parseInt(get_user.step) == 1 )?'disbale':''">                       
                        <a href="#" :class="(tab_active == 3)?'active':''" @click.prevent="tab_active = 3">
                            <span class="steps">1</span>
                            <h3>Upload Personal Documents</h3>
                        </a>   
                    </li>
                </ul>
            </div>
        </div> -->
        <!-- step 1 -->
        <div class="row justify-content-center align-items-center " >
            <div class="stepArea my-5 middleBox">
                <!-- <h2 class="title mb-4 text-left ">{{$t('personalInfo')}}</h2> -->
                <div class="whiteBG p-3 Step-Form  "> 
                    
                    <!--loader - message--->
                    <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
        <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
                    <!--------------------------individual------------------------------->
                    <div class="stepForm row" > 
                        <h3 class="mb-3 w-100 pl-3">{{$t('step1_personalinfo')}}</h3>  
                        <div class="col-12 col-md-6 mobPad mb-4">
                            <div class="form-group field-wrapper  m-0">
                                <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="ind_f_name"  v-validate="'required'" name="first name" class="float-field form-control"  :class="{ 'is-invalid': submittedRequest && errors.has('first name') }" :disabled="disable" />
                                    <label for="password" class="float-label">{{$t('step1_fname')}}<sup class="red">*</sup></label>
                                </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('first name')">{{ error }}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad mb-4">
                            <div class="form-group field-wrapper  m-0">
                            <div class="position-relative"> 
                                <input placeholder=" " type="text" v-model="ind_l_name" class="float-field form-control" v-validate="'required'" name="last name"  :class="{ 'is-invalid': submittedRequest && errors.has('last name') }"  :disabled="disable"/>
                                <label for="password"  class="float-label">{{$t('step1_lname')}}<sup class="red">*</sup></label>
                            </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('last name')">{{ error }}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad mb-4" >
                            <div class="form-group field-wrapper m-0 active"> 
                                <div class="position-relative">
                                <label for="password" class="Date_Birth">{{$t('step1_dob')}}<sup class="red">*</sup></label>
                                <!-- <datepicker v-model="ind_dob" type="date" :editable=false  placeholder=" " class="customflaotField mdb-select md-form   form-control"   name="dob" v-validate="{ required: true , date_format:'YYYY-MM-DD' }" :lang="lang" :class="(ind_dob != '' && ind_dob != 'Invalid Date'?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('dob') })"   :disabled="disable" ></datepicker> -->
                                <input name="before_field_target" ref="beforeTarget" v-model="age18Greater" type="hidden">
                                <input name="before_field_target" ref="afterTarget" v-model="minDate" type="hidden">
                                <input class="customflaotField mdb-select md-form form-control pt-0" type="date" v-model="ind_dob"  name="dob" v-validate="'required|after:afterTarget|before:beforeTarget'" :min="minDate" :max="maxDate()"  :class="(ind_dob != '' && ind_dob != 'Invalid Date'?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('dob') })" :disabled="disable" />
                            </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('dob')">
                                    <span v-if="error.includes('required') || ind_dob == 'Invalid Date'">{{$t('step1_dobrequired')}}</span>
                                    <span v-else-if="error.includes('afterTarget')">{{$t('step1_minimumdate')}}</span>
                                    <span v-else-if="error.includes('beforeTarget')">{{$t('step1_below18')}}</span>
                                    
                                </p> 
                            </div>
                        </div>
                       
                        <h3 class="mb-3 w-100 pl-3">{{$t('step1_addinfo')}}</h3>  
                        <div class="col-12 col-md-6 mobPad  mb-4">
                            <div class="form-group field-wrapper  m-0">
                                <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="address1" class="float-field form-control" v-validate="'required'" name="address1"  :class="{ 'is-invalid': submittedRequest && errors.has('address1') }"   :disabled="disable"/>
                                    <label for="password" class="float-label">{{$t('prof_addressLine1')}} <sup class="red">*</sup></label>
                                </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('address1')">{{ error }}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad  mb-4">
                            <div class="form-group field-wrapper  m-0">
                                <div class="position-relative">
                                    <input placeholder=" " type="text"  class="float-field form-control"  name="address2"  v-model="address2":disabled="disable"/>
                                    <label for="password" class="float-label">{{$t('prof_addressLine2')}}</label>  
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad mb-4">
                            <div class="form-group field-wrapper  m-0"> 
                                <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="ind_city" class="float-field form-control" v-validate="'required'" name="city"  :class="{ 'is-invalid': submittedRequest && errors.has('city') }"  :disabled="disable"/>
                                    <label for="password"  class="float-label">{{$t('step1_city')}}<sup class="red">*</sup></label>
                                </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('city')">{{ error }}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad mb-4">
                            <div class="form-group field-wrapper  m-0">
                                <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="ind_post_code" class="float-field form-control" v-validate="'required'" name="post code"  :class="{ 'is-invalid': submittedRequest && errors.has('post code') }"  :disabled="disable"/>
                                    <label for="password" class="float-label">{{$t('step1_postalcode')}}<sup class="red">*</sup></label>
                                </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('post code')">{{ error }}</p>   
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mobPad mb-4">
                            <div class="form-group field-wrapper  m-0 tabClass" >
                                <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="ind_residence_country" class="float-field form-control"  name="residence country"    :disabled="disable" readonly />
                                    <label for="password" class="float-label">{{$t('step1_countryRes')}}<sup class="red">*</sup></label>
                                </div>
                            </div> 
                        </div>
                         
                        <div class="col-12 col-md-6 mobPad  mb-4">
                            <div class="form-group field-wrapper  m-0">
                                <!-- <div class="position-relative">
                                    <input placeholder=" " type="text" v-model="phone_no" class="float-field form-control" name="phone_no"  :class="{ 'is-invalid': submittedRequest && errors.has('phone_no') }" :disabled="disable" v-validate="{ required: true, regex: /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/}"/>
                                    <label for="password" class="float-label">{{$t('step1_phno')}}<sup class="red">*</sup></label>
                                </div>
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('phone_no')">
                                    <span v-if="error.includes('required')">{{$t('step1_phnoRequired')}}</span>
                                    <span v-else-if="error.includes('invalid')">{{$t('step1_correctno')}}</span>
                                </p>   -->
                                <div class="form-group field-wrapper  m-0">
                                   <vue-phone-number-input v-model="mobile_number"  :no-example="true"  v-validate="{required: true,min:8, max:15}" ref="mobile_numberInput" :class="{ 'is-invalid': submittedRequest && errors.has('phone_no') }" name="phone_no" @update="updatedText"/>
                                    <!-- <label for="password" class="float-label">{{$t('step1_phno')}}<sup class="red">*</sup></label> -->
                                    <p class="error"  v-for="error in errors.collect('phone_no')">
                                        <span v-show="submittedRequest && error == 'The phone_no field is required.'">{{$t('step1_phnoRequired')}}</span>
                                        <span v-show="error == 'The phone_no field must be at least 8 characters.'">{{$t('step1_minimumph')}}</span>
                                         <span v-show="error == 'The phone_no field may not be greater than 15 characters.'">{{$t('step1_maxphone')}}</span>
                                        <!-- <span v-else-if="error.includes('invalid')">{{$t('step1_correctno')}}</span> -->
                                    </p>  
                                <!-- <p class="error" v-if="numberValid == false">The phone number is invalid.</p> -->
                                </div>
                            </div>
                        </div>
                      
                       
                        <div class="col-12 mobPad">
                            <div class="full-width border-top pt-3 submitButton align-items-center d-flex justify-content-end mt-3 w-100">
                                <button class="prism_btn btn_sm" v-on:click.prevent="submit()">{{$t('step1_Next')}}</button>
                            </div>
                        </div>
                    </div>

                    <!--------------------------joint------------------------------->
                   

                    <!--------------------------corporate------------------------------->
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vue2-datepicker';
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'stepOne',
        data() {
            return {
                ind_f_name : '',
                ind_l_name : '',
                ind_residence_country : '',
                ind_post_code : '',
                ind_city : '',
                ind_pep : false,
                ind_dob : '',

                joint_f_name_member1 : '',
                joint_l_name_member1 : '',
                joint_dob_member1 : '',
                joint_f_name_member2 : '',
                joint_l_name_member2 : '',
                joint_dob_member2 : '',

                cor_incor_date : '',
                cor_company_name : '',
                cor_dob : '',
                cor_f_name : '',
                cor_l_name : '',

                phone_no : '',
                address1 : '',
                mobile_number :'',
                numberWithCountry:'',
                numberValid: true,
                us_person : false,

                step : '1',
                disabledDates :{
                    from : new Date().setDate(new Date().getDate() - 18250),
                    to : new Date().setDate(new Date().getDate() - 4850)
                },
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                    monthBeforeYear: false,
                },
                tabActive : '',
                pageLoader : false,
                msg_type : '',
                response_msg : '',
                submittedRequest : false,
                disable: false,
                select_currency : '',
                address2 : '',
                age18Greater: moment(new Date().setTime(Date.now().valueOf() - 18 * 365 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'),
                currentDate: moment(new Date()).format('YYYY-MM-DD'),
                minDate : moment('1920-01-01').format('YYYY-MM-DD')
            }
        }, 
        methods:{
            /*age18Greater(){
                var eighteenYearsAgo = new Date();
                eighteenYearsAgo.setTime(eighteenYearsAgo.valueOf() - 18 * 365 * 24 * 60 * 60 * 1000);
                return eighteenYearsAgo
            }*/
            maxDate(){
                return moment().format('YYYY-MM-DD');
            },
            
            updatedText(e){
                this.numberWithCountry = e.formattedNumber
                this.numberValid = e.isValid
            },
            countryFunc(){
                let count = 0 ;
                for(var key in  this.countriesList){
                    count++
                    if(this.countriesList[key].iso2 == this.get_user.country){
                        this.ind_residence_country =  this.countriesList[key].name
                    }
                }
            },
            /*checkGreaterAge(){
                if(this.dob){
                    const dateB = moment(); 
                    const dateC = moment(this.dob).format('YYYY-MM-DD'); 
                    const age = dateB.diff(dateC, 'years');
                    if(age < 18){
                         this.greaterthan68 = true
                    }else{
                        this.greaterthan68 = false
                    }
                }
            },*/
            tabActiveFun(getData){
                this.tabActive = getData
            },
            /*next(){
                const _that = this
                this.submittedRequest = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                     const dateB = moment(); 
                        const dateC = moment(_that.dob).format('YYYY-MM-DD'); 
                        const age = dateB.diff(dateC, 'years');
                        if(age < 18){
                             _that.greaterthan68 = true
                        } else if(age > 68){
                            _that.greaterthan68 = true
                        }else{
                         _that.info_var = '2'
                            // this.countrySelectFunc()
                         _that.countrySelectFunc()
                     }
                 }
                });
            },*/
            customFormatter(date) {
                return moment(date).format('DD-MM-YYYY');
            },
            ...mapActions({
                _runRegisterStepOne: types.RUN_REGISTER_STEP1
            }),
            submit(){
                if(this.disable){
                    this.$router.replace('/step2')
                }else{
                    const _that = this
                    this.submittedRequest = true;
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            let input_json={
                                'globalParams' :{
                                    'step'                  :       _that.step,
                                    'mobile_no'             :       _that.numberWithCountry,
                                    'address1'              :       _that.address1 ,
                                    'address2'              :       _that.address2 ,
                                    
                                    'residence_country'     :       _that.get_user.country, 
                                    'post_code'             :       _that.ind_post_code ,
                                    'city'                  :       _that.ind_city ,

                                    'mname' : '' ,
                                    'nationality' : '',
                                    'corr_address1' : '',
                                    'corr_address2' : '',
                                    'corr_post_code' : '',
                                    'corr_city' : '',
                                    'crs' : '',
                                    'mifir': '',
                                    'mifir_type': '',
                                    'idproof': '',
                                    'p_id' : '',
                                    'gender' : '',
                                    'res_tax': ''
                                },
                                'localParams' :{ "parameter" : _that , 'step' : _that.step}
                            } 
                            input_json.globalParams.fname                 =       _that.ind_f_name 
                                input_json.globalParams.lname                 =       _that.ind_l_name 
                                input_json.globalParams.dob                   =       moment(_that.ind_dob).format('YYYY-MM-DD')
                        
                            _that._runRegisterStepOne(input_json)
                        }else{
                            _that.handleValidationErrorAdvanced(_that.errors)
                        }
                    }); 
                }
            }
        },
        components: {
            datepicker : Datepicker
        },
        created(){ 
            this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : this.step,"tab" : 1}})
        },
        mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.tabClass').length){
                    _that.tabActive = ''
                }
            });
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step1.vue